import { FieldOption } from 'module/api/field/types';
import { SignalOccurrence } from 'api/timeline/types';
import { DetectedSignal } from 'api/timeline/types';
import { BaseCustomSectionAttributes, CustomSectionType } from './common';

export enum SignalOption {
  ALL = 'ALL',
  SPECIFIC = 'SPECIFIC',
}

export type SignalType = SignalOption;

export type SignalCustomSectionConfig = {
  signalOption: SignalOption;
  signalConfigurationIds?: number[];
};
export type SignalCustomSectionAttributes = Omit<
  BaseCustomSectionAttributes,
  'title'
> & {
  sectionType: CustomSectionType.SignalDetails;
  signalType?: SignalType;
  signalsSelected?: FieldOption<number>[];
  config: SignalCustomSectionConfig;
  response?: {
    signalOccurences: SignalOccurrence[];
    detectedSignals: DetectedSignal[];
  };
};
